import Cookies from 'js-cookie'
import { createInitialState, createSessionId } from './state'
import { isCurrentPaymentSystem } from './modules/payment/constants'

const clearAuthCookies = () => {
  Cookies.remove('access')
  Cookies.remove('refresh')
  Cookies.remove('project_id')
  Cookies.remove('associate_number')
}

export default {
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_LOGGING_OUT(state, value) {
    state.isLoggingOut = value
  },
  setToken(state, token) {
    state.token = token
  },
  rotateSessionId(state) {
    state.sessionId = createSessionId()
  },
  clearApplicationState(state, payload = {}) {
    const preserve = payload?.preserve ?? {}
    const nextState = createInitialState()

    nextState.token = null

    Object.assign(nextState, preserve)
    Object.assign(state, nextState)

    localStorage.removeItem('applicationState')
    clearAuthCookies()
  },
  setUser(state, user) {
    state.user = user
  },
  setAssociate(state, associate) {
    state.associate = associate
  },
  setResponsibleContacts(state, contacts) {
    state.responsibleContacts = contacts
  },
  setCurrentProject(state, currentProject) {
    state.currentProject = currentProject
  },
  setAllProjects(state, allProjects) {
    state.allProjects = allProjects
  },
  setDateFromFilter(state, dateFrom) {
    state.dateFromFilter = dateFrom
  },
  setDateToFilter(state, dateTo) {
    state.dateToFilter = dateTo
  },
  setTimeCardsSelectedEmployee(state, selectedEmployee) {
    state.timeCardsSelectedEmployee = selectedEmployee
  },
  setShiftAuthSelectedEmployee(state, selectedEmployee) {
    state.shiftAuthSelectedEmployee = selectedEmployee
  },
  setTimeZone(state, timeZone) {
    state.timeZone = timeZone
    localStorage.setItem('timeZone', timeZone)
  },
  setCurrentPaymentType(state, paymentType) {
    state.currentPaymentType = paymentType
  },
  setCurrentPaymentTypeName(state, paymentTypeName) {
    state.currentPaymentTypeName = paymentTypeName
  },
  setExtendedShiftAuthTypes(state, types) {
    state.extendedShiftAuthTypes = types
  },
  setTimeConstants(state, constants) {
    state.timeConstants = constants
  },
  setProjectRoles(state, roles) {
    state.projectRoles = roles
  },
  setProjectLegalEntities(state, legalEntities) {
    state.projectLegalEntities = legalEntities
  },
  setProjectPaymentSystems(state, payload) {
    state.projectPaymentSystems = payload.filter(isCurrentPaymentSystem)
  },
  setProjectPayCodes(state, payload) {
    state.projectPayCodes = payload
  },
  setProjectDepartments(state, payload) {
    state.projectDepartments = payload
  },
  setApplicationState(state, newState) {
    Object.assign(state, newState)
  },
  setNeedUpdate(state, newState) {
    state.needUpdate = newState
  },
  setInternetConnectionState(state, payload) {
    const nextPayload = { ...payload }

    if (nextPayload.stable === true) {
      nextPayload.dismissed = false
    }

    state.internetConnection = {
      ...state.internetConnection,
      ...nextPayload
    }
  },
  setWorkAreas(state, payload) {
    state.workAreas = payload
  },
  setReports(state, payload) {
    state.reports = payload
  }
}
